import {LocalCache} from "~/infra/cache/local-cache";

export const makeCache = () => {
  return new LocalCache();
};
